import React from 'react';

function CalendarKey() {
    return (
        <div className="calendar-key">
            <h4 className="heading">Key</h4>
            <div className="calendar-keys">
                <div className="single-key">
                    <span className="calendar-key__icon available"></span>
                    <p>Available</p>
                </div>
                <div className="single-key">
                    <span className="calendar-key__icon mixedavailable"></span>
                    <p>Partially available</p>
                </div>
                <div className="single-key">
                    <span className="calendar-key__icon unavailable"></span>
                    <p>Unavailable</p>
                </div>
                <div className="single-key">
                    <span className="calendar-key__icon no-data"></span>
                    <p>No availability information</p>
                </div>
                <div className="single-key">
                    <span className="calendar-key__icon not-working-day"></span>
                    <p>Non working day</p>
                </div>
            </div>
        </div>
    );
};

export default CalendarKey;
